import Vue from "vue";
import VueRouter from "vue-router";

import firebase from "firebase/compat/app";
import "firebase/compat/auth";

import { captureException } from "@/posthog";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: {
      forceDashboard: true,
    },
  },
  {
    path: "/login/application",
    name: "LoginApplication",
    component: () => import("@/views/LoginApplication.vue"),
    meta: {
      hideShell: true,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/Register.vue"),
    meta: {
      forceDashboard: true,
    },
  },
  {
    path: "/",
    name: "dashboard",
    component: () => import("@/views/Dashboard.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("@/views/Profile"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
  },
  {
    path: "/my-company",
    name: "Mon entreprise",
    component: () => import("@/views/MyCompany.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
  },

  // MODULES
  {
    path: "/projects",
    name: "Projects",
    component: () => import("@/views/Projects"),
    meta: {
      requiresAuth: true,
      module: "Dk1wdkEvdgyIPmJAg1uv",
      safePlace: true,
    },
  },
  {
    path: "/team",
    name: "Team",
    component: () => import("@/views/Teams.vue"),
    meta: {
      requiresAuth: true,
      module: "GPvYlONpjCDqzW6sckkw",
      safePlace: true,
    },
  },
  {
    path: "/customers",
    name: "Customers",
    component: () => import("@/views/Customers.vue"),
    meta: {
      requiresAuth: true,
      modules: "WMNeXSrh3zlFzIBCZPAq",
      safePlace: true,
    },
  },
  {
    path: "/companies",
    name: "Companies",
    component: () => import("@/views/Companies.vue"),
    meta: {
      requiresAuth: true,
      module: "WMNeXSrh3zlFzIBCZPAq",
      safePlace: true,
    },
  },
  {
    path: "/quotes",
    name: "Quotes",
    component: () => import("@/views/Quotes.vue"),
    meta: {
      requiresAuth: true,
      module: "YzeCWO5vQIgYKrdZCuWz",
      safePlace: true,
    },
  },
  {
    path: "/invoices",
    name: "Invoices",
    component: () => import("@/views/Invoices.vue"),
    meta: {
      requiresAuth: true,
      module: "JAms0PMwguesdZvvXvIL",
      safePlace: false,
    },
  },
  {
    path: "/products",
    name: "Products",
    component: () => import("@/views/Products.vue"),
    meta: {
      requiresAuth: true,
      module: "dBNa5WjEnL1tjUJBDVHd",
      safePlace: true,
    },
  },
  {
    path: "/warehouses",
    name: "Warehouses",
    component: () => import("@/views/Warehouses.vue"),
    meta: {
      requiresAuth: true,
      module: "kEUEhxSoDZWSVjNkGIy7",
      safePlace: true,
    },
  },
  {
    path: "/logistics",
    name: "Logistics",
    component: () => import("@/views/Logistics.vue"),
    meta: {
      requiresAuth: true,
      module: "kEUEhxSoDZWSVjNkGIy7",
      safePlace: true,
    },
  },
  {
    path: "/tools",
    name: "Tools",
    component: () => import("@/views/Tools.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
  },
  {
    path: "/tools/qrcode",
    name: "QR_Code",
    component: () => import("@/views/tools/GenerateQR.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
  },
  {
    path: "/help",
    name: "Help",
    component: () => import("@/views/Help.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
  },
  {
    path: "/help/:slug",
    name: "HelpArticle",
    component: () => import("@/views/Help.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
    props: true,
  },
  {
    path: "/blogs",
    name: "Blogs",
    component: () => import(`@/views/Blogs.vue`),
    meta: {
      requiresAuth: true,
      module: "zS95PXCJ8QRCXsNgRMSX",
      safePlace: true,
    },
  },
  {
    path: "/tasks",
    name: "Tasks",
    component: () => import(`@/views/Tasks.vue`),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
  },
  // ADMINISTRATION
  {
    path: "/administration",
    name: "Administration",
    component: () => import("@/views/administration/Dashboard.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
  },
  {
    path: "/administration/creation",
    name: "Creation",
    component: () => import("@/views/administration/Creation.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
  },
  {
    path: "/administration/catalog",
    name: "AdminCatalog",
    component: () => import("@/views/administration/Catalog.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
  },
  {
    path: "/administration/notifications",
    name: "AdminNotifications",
    component: () => import("@/views/administration/Notifications.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
  },
  {
    path: "/administration/company/:id",
    name: "AdminCompany",
    component: () => import("@/views/administration/manage/Company.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
    props: true,
  },
  {
    path: "/administration/customer/:id",
    name: "AdminCustomer",
    component: () => import("@/views/administration/manage/Customer.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
    props: true,
  },
  {
    path: "/administration/sandbox",
    name: "Sandbox",
    component: () => import("@/views/administration/Sandbox.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
    props: true,
  },
  {
    path: "/administration/dbcrawler",
    name: "DB_Crawler",
    component: () => import("@/views/administration/DBCrawler.vue"),
    meta: {
      requiresAuth: true,
      safePlace: true,
    },
    props: true,
  },
  // FICHES INDIVIDUELLES
  {
    path: "/record/company/:id",
    name: "Company",
    component: () => import("@/views/record/Company.vue"),
    meta: {
      requiresAuth: true,
      module: "WMNeXSrh3zlFzIBCZPAq",
    },
    props: true,
  },
  {
    path: "/record/product/:id",
    name: "Product",
    component: () => import("@/views/record/Product.vue"),
    meta: {
      requiresAuth: true,
      module: "dBNa5WjEnL1tjUJBDVHd",
    },
    props: true,
  },
  {
    path: "/record/customer/:id",
    name: "Customer",
    component: () => import("@/views/record/Customer.vue"),
    meta: {
      requiresAuth: true,
      module: "WMNeXSrh3zlFzIBCZPAq",
    },
    props: true,
  },
  {
    path: "/record/quote/:id",
    name: "Quote",
    component: () => import("@/views/record/Quote.vue"),
    props: true,
  },
  {
    path: "/record/quote/:id/:companyId",
    name: "PublicQuote",
    component: () => import("@/views/record/Quote.vue"),
    props: true,
  },
  {
    path: "/record/invoice/:id",
    name: "Invoice",
    component: () => import("@/views/record/Invoice.vue"),
    props: true,
  },
  {
    path: "/record/invoice/:id/:companyId",
    name: "PublicInvoice",
    component: () => import("@/views/record/Invoice.vue"),
    props: true,
  },
  {
    path: "/record/project/:id",
    name: "Project",
    component: () => import(`@/views/record/Project.vue`),
    meta: {
      requiresAuth: true,
      module: "Dk1wdkEvdgyIPmJAg1uv",
    },
    props: true,
  },
  {
    path: "/record/warehouse/:warehouseId",
    name: "Warehouse",
    component: () => import(`@/views/record/Warehouse.vue`),
    meta: {
      requiresAuth: true,
      module: "kEUEhxSoDZWSVjNkGIy7",
    },
    props: true,
  },
  {
    path: "/record/selling-point/:id",
    name: "SellingPoint",
    component: () => import(`@/views/record/SellingPoint.vue`),
    meta: {
      requiresAuth: true,
      module: "kEUEhxSoDZWSVjNkGIy7",
    },
    props: true,
  },

  {
    path: "/blog/:id",
    name: "Blog",
    component: () => import(`@/views/record/Blog.vue`),
    meta: {
      requiresAuth: true,
      module: "zS95PXCJ8QRCXsNgRMSX",
    },
    props: true,
  },
  {
    path: "/blog/:id/add",
    name: "AddBlog",
    component: () => import(`@/views/blog/Add.vue`),
    meta: {
      requiresAuth: true,
      module: "zS95PXCJ8QRCXsNgRMSX",
    },
    props: true,
    children: [
      {
        path: ":modArticle",
      },
    ],
  },
  {
    path: "/blog/:id/articles",
    name: "Articles",
    component: () => import(`@/views/blog/Articles.vue`),
    meta: {
      requiresAuth: true,
      module: "zS95PXCJ8QRCXsNgRMSX",
    },
    props: true,
  },
  {
    path: "/blog/:id/article/:idArticle",
    name: "Article",
    component: () => import(`@/views/record/Article.vue`),
    meta: {
      requiresAuth: true,
      module: "zS95PXCJ8QRCXsNgRMSX",
    },
    props: true,
  },

  // STRIPE
  {
    path: "/stripe/checkout/:company/:session",
    name: "PageCheckoutSessionSuccess",
    component: () => import(`@/views/stripe/CheckoutSessionSuccess.vue`),
    meta: {
      requiresAuth: false,
    },
    props: true,
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("@/views/NotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.onError((error) => {
  captureException(error, {
    flow: "vue_router",
  });
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = firebase.auth().currentUser;

  const requiresAuth = to.meta.requiresAuth ?? false;
  const forceDashboard = to.meta.forceDashboard ?? false;

  if (requiresAuth && !isAuthenticated)
    next("/login");
  else if (forceDashboard && isAuthenticated)
    next("/");
  else
    next();
});

export default router;
